/**
 * Created by Languagenut on 16/04/2019.
 */


/**
 * Created by Languagenut on 16/04/2019.
 */

import React  from 'react';
import {Badge , Navbar  , Nav , NavDropdown} from 'react-bootstrap'
import AnimatedNumber from 'react-animated-number';

export default class LiveMemebers extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:"active",
            toggle:false,
            totalStudents:30,
            totalActiveStudents:16,
            totalDormantStudents:4,
            totalOfflineStudents:10,
        };
    }

    componentWillUnmount(){

    }

    handleSelect(eventKey){
        this.setState({tab:eventKey})
    }

    onClick(){
        this.setState({
            toggle:!this.state.toggle,
        })
    }

    getBody()
    {
        switch(this.state.tab)
        {
            case "students" : return <h4>Students</h4>
            case "staff" : return <h4>Students</h4>
        }
    }

    getPercentage(){



    }

    render(){

        let bigValue = 1100;
        return <div>


            <Navbar style={{padding:0}}>
                <Nav defaultActiveKey={this.state.tab} onSelect={k => this.handleSelect(k)}>
                    <Nav.Item>
                        <Nav.Link style={{paddingLeft:"0"}} eventKey="active">
                            Active Students&nbsp;&nbsp;
                            <Badge pill style={{verticalAlign: "text-top"}} variant={this.state.totalActiveStudents > this.state.totalStudents/2 ? "success" : "warning"}>
                                <AnimatedNumber component="text" initialValue={0} value={this.state.totalActiveStudents} duration={1000} stepPrecision={0}/>
                            </Badge>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="dormant">Dormant Students&nbsp;&nbsp;
                            <Badge pill style={{verticalAlign: "text-top"}} variant={this.state.totalDormantStudents == 0 ? "secondary" :"danger"}>
                                <AnimatedNumber component="text" initialValue={0} value={this.state.totalDormantStudents} duration={1000} stepPrecision={0}/>
                            </Badge>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="offline">Offline Students&nbsp;&nbsp;
                            <Badge pill style={{verticalAlign: "text-top"}} variant="secondary">
                                <AnimatedNumber component="text" initialValue={0} value={this.state.totalOfflineStudents} duration={1000} stepPrecision={0}/>
                            </Badge>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                <Navbar.Collapse className="justify-content-end">
                    <NavDropdown drop={"down"} title="Actions" id="basic-nav-dropdown">
                        <NavDropdown.Item href="#action/3.2">Redirect All</NavDropdown.Item>
                        <NavDropdown.Item href="#action/3.3">Message  All</NavDropdown.Item>
                        <NavDropdown.Item href="#action/3.3">Reward   All</NavDropdown.Item>
                    </NavDropdown>
                </Navbar.Collapse>
            </Navbar>
            <hr/>
            <div>
            </div>
        </div>
    }
}
